import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findNotificationLogs = (headers, params) => {
    let query = buildQuery(params, []);
    return axios.get(`${process.env.REACT_APP_ACM_API_URL}/notification-logs${query}`, {
        headers,
    });
};
